import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import { AdminPages } from '../AdminPages';
import { SORT_ASC, SORT_DESC } from '../../../utilities/FormUtilities';
import { DELETE, DISABLE, ENABLE, PRE_DELETE, RESCAN } from '../../../services/FormDataTableActionService';

export const VIRTUAL_INFRASTRUCTURE_FUNCTION_NAME = AdminPages.VirtualInfrastructure;
export const MONITORED_INTERFACES_FUNCTION_NAME = AdminPages.Interfaces;
export const VIRTUAL_INFRASTRUCTURE_DETAIL_FUNCTION_NAME = 'virtual-infrastructure-detail';
export const MONITORED_INFRASTRUCTURE_DETAIL_FUNCTION_NAME = 'monitored-infrastructure-detail';
export const MONITORED_INFRASTRUCTURE_FUNCTION_NAME = AdminPages.MonitoredInfrastructure;
export const LIST_COLLECTORS_ID = 'plcId';
export const NEW_VCENTER_BREAD_CRUMB_TEXT = i18n._(t`New vCenter`);
export const NEW_BREAD_CRUMB_TEXT = i18n._(t`New`);
export const VIRTUAL_INFRASTRUCTURE_TITLE = i18n._(t`VMware® Infrastructure`);
export const MONITORED_INFRASTRUCTURE_TITLE = i18n._(t`Monitored Infrastructure`);
export const MONITORED_INTERFACES_TITLE = i18n._(t`Interfaces`);

export const VIRTUAL_INFRASTRUCTURE_ADMIN_LIST_DATA_TABLE_ID = 'virtualInfrastructure-list';
export const MONITORED_INTERFACES_ADMIN_LIST_DATA_TABLE_ID = 'interfaces-list';
export const VIRTUAL_INFRASTRUCTURE_ADMIN_LIST_DATA_EMPTY_TEXT = 'No VMware found';
export const MONITORED_INTERFACE_ADMIN_LIST_DATA_EMPTY_TEXT = 'No Interface found';
export const MONITORED_INFRASTRUCTURE_ADMIN_LIST_DATA_EMPTY_TEXT = 'No devices found';
export const MONITORED_INFRASTRUCTURE_ADMIN_LIST_DATA_TABLE_ID = 'device-list';
export const VIRTUAL_MACHINES_ADMIN_LIST_DATA_TABLE_ID = 'admin-virtual-machines-list';
export const VIRTUAL_MACHINES_ADMIN_LIST_EMPTY_STATE_MESSAGE = 'No virtual machines available for this hypervisor';
export const HYPERVISOR_ADMIN_LIST_DATA_TABLE_ID = 'admin-hypervisor-list';
export const HYPERVISOR_ADMIN_LIST_EMPTY_STATE_MESSAGE = 'No hypervisors available for this vCenter';
export const INFRASTRUCTURE_COLLECT_LIST_DATA_TABLE_ID = 'admin-infrastructure-collect-list';
export const VMWARE_HOST_DETAIL = 'vmware-host-detail';
export const VMWARE_VM_DETAIL = 'vmware-vm-detail';
export const APP_AUTH_PAGE = 'app.auth.page';
export const TITLE_MAPPING = 'title';
export const ID_MAPPING = '_id';
export const NAME_FIELD = 'name';
export const NORM_NAME_FIELD = 'norm_name';
export const IPADDRESS_FIELD = 'ipAddress';
export const IPADDRESSES_FIELD = 'ipAddresses';
export const PLCNAME_FIELD = 'plcName';
export const UISTATE_FIELD = 'uiState';
export const SUBTYPE_FIELD = 'subType';
export const DEVICE_TYPE_FIELD = 'deviceType';
export const DEVICE_NAME_FIELD = 'deviceName';
export const DEVICE_FIELD = 'device';
export const DEVICE_IP_ADDRESS_FIELD = 'deviceIpAddress';

export const DESCRIPTION_FIELD = 'description';
export const POLLING_STATUS_FIELD = 'pollingStatus';
export const PRIORITY_STATUS_FIELD = 'priorityStatus';
export const IF_TYPE_FIELD = 'ifType';
export const IF_MODE_FIELD = 'ifMode';
export const IF_ADMIN_STATUS_FIELD = 'ifAdminStatus';
export const IF_OP_STATUS_TEXT_FIELD = 'ifOpStatusText';
export const DISPLAY_SPEED_FIELD = 'displaySpeed';

export const CB_QOS_CLASSES_FIELD = 'cbQosClasses';
// export const CB_QOS_CLASSES_NAME_FIELD = 'cbQosClasses.name';
export const CB_QOS_CLASSES_NAME_FIELD = CB_QOS_CLASSES_FIELD;

export const MAPPING_CLUSTER_FIELD = 'virtualization.cluster';
export const MAPPING_VCENTER_FIELD = 'virtualization.vCenter';
export const MAPPING_VCENTER_UUID_FIELD = 'virtualization.vCenterUuid';
export const MAPPING_RESOURCEPOOL_FIELD = 'virtualization.resourcePool';
export const MAPPING_TAGS_FIELD = 'virtualization.tags';
export const MAPPING_HYPERVISORNAME_FIELD = 'virtualization.hyperVisorName';
export const MAPPING_HYPERVISOR_ID_FIELD = 'virtualization.parentUuid';
export const MAPPING_DATACENTER_FIELD = 'virtualization.dataCenter';

export const MAPPING_TEST_TIME_FIELD = 'testTime';
export const MAPPING_CLASSIFIERLOG_SUCCESS_FIELD = 'classifierlog.success';
export const MAPPING_CLASSIFIERLOG_TIME_FIELD = 'classifierlog.time';

export const MAPPING_CLASSIFIERLOG_PROTOCOL_FIELD = 'classifierlog.protocol';
export const MAPPING_CLASSIFIERLOG_CREDENTIAL_FIELD = 'classifierlog.credential';
export const MAPPING_CLASSIFIERLOG_REASON_FIELD = 'classifierlog.reason';

export const LABEL_NAME = t`Name`;
export const LABEL_DEVICE_NAME_NAME = t`Device Name`;
export const LABEL_HOSTNAME = t`Hostname`;
export const LABEL_HOSTNAME_IP = t`Hostname/IP`;
export const HOSTNAME_FIELD = 'virtualization.guestInfo.hostname';

export const LABEL_USERNAME = t`Username`;
export const USERNAME_FIELD = 'virtualization.username';

export const LABEL_PASSWORD = t`Password`;
export const PASSWORD_FIELD = 'virtualization.password.value';

export const LABEL_PORT = t`Port`;
export const PORT_FIELD = 'virtualization.portNumber';

export const DEFAULT_PORT_NUMBER = 443;
export const LABEL_TOTAL_ENTITIES = t`Total Entities`;

export const VCENTER_HOSTNAME_FIELD = 'hostname';
export const MANUAL_NAME = 'manualName';
export const INSERT_TIME = 'insertTime';
export const DISCOVERY_PLC = 'discoveryPlc';
export const OWNER_PLC = 'ownerPlc';
export const MONITORING_PLC = 'monitoringPlc';
export const MONITORING_PLC_NAME = 'monitoringPlcName';
export const LABEL_IP_ADDRESS = t`IP Address`;
export const LABEL_DEVICE_IP_ADDRESS = t`Device IP`;
export const LABEL_IP_ADDRESSES = t`IP Addresses`;
export const LABEL_COLLECTOR = t`Collector`;
export const LABEL_STATUS = t`Status`;
export const LABEL_POLLING_STATUS = t`Polling Status`;
export const LABEL_TYPE = t`Type`;
export const LABEL_VIRTUAL_TYPE = t`Virtual Type`;
export const POWERSTATE_FIELD = 'virtualization.powerState';
export const LABEL_POWER_STATE = t`Power State`;
export const LABEL_UP_TIME = t`Up Time`;
export const BOOT_TIME_FIELD = 'virtualization.bootTime';

export const LABEL_VENDOR = t`Vendor`;
export const VENDOR_FIELD = 'vendor';

export const LABEL_TECHNOLOGY = t`Technology`;
export const TECHNOLOGY_FIELD = 'virtualization.technology';

export const LABEL_CPU_INFO = t`CPU Info`;
export const CPU_INFO_FIELD = 'virtualization.cpuInfo';

export const LABEL_MEMORY_SIZE = t`Memory Size`;
export const MEMORY_SIZE_FIELD = 'virtualization.memorySize';

export const LABEL_RESOURCEPOOL = t`Resource Pool`;
export const RESOURCEPOOL_FIELD = 'virtualization.resourcePool';

export const LABEL_VERSION = t`Version`;
export const VERSION_FIELD = 'virtualization.version';
export const LABEL_VCENTER = t`vCenter`;
export const LABEL_DATA_CENTER = t`Data Center`;
export const LABEL_CLUSTER = t`Cluster`;
export const LABEL_HYPERVISOR = t`Hypervisor`;
export const LABEL_SITES = t`Sites`;
export const LABEL_SITE_NAME = t`Site`;
export const PAGE_SITE = '/site-detail';
export const LABEL_DESCRIPTION = t`Description`;
export const LABEL_TIME_TAMP = t`Time Stamp`;
export const LABEL_RESULT = t`Result`;
export const LABEL_PROTOCOL = t`Protocol`;
export const LABEL_CREDENTIAL = t`Credential`;
export const LABEL_LOG_MESSAGE = t`Log Message`;

const NAME_ASC_SORT_FIELD_INFO = [
    {
        property: NAME_FIELD,
        direction: SORT_ASC,
    },
];
export const MONITORED_INFRASTRUCTURE_INITIAL_SORT_FIELD_INFO = NAME_ASC_SORT_FIELD_INFO;
export const VIRTUAL_INFRASTRUCTURE_INITIAL_SORT_FIELD_INFO = NAME_ASC_SORT_FIELD_INFO;
export const MONITORED_INTERFACE_INITIAL_SORT_FIELD_INFO = NAME_ASC_SORT_FIELD_INFO;
export const INFRASTRUCTURE_LIST_INITIAL_SORT_FIELD_INFO = [
    {
        property: NORM_NAME_FIELD,
        direction: SORT_DESC,
    },
];

export const QUERY_LOADER_OPTION = { disableFilterState: false };
export const MONITORED_INFRASTRUCTURE_DATA_SOURCE = {
    url: '/query/admin/monitoredDeviceConfig',
    crudUrl: '/ipm/v1/admin/monitoredDeviceConfig',
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: [IPADDRESS_FIELD, PLCNAME_FIELD, DESCRIPTION_FIELD, NAME_FIELD, DEVICE_TYPE_FIELD, UISTATE_FIELD],
    },
};

const DEVICE_INTERFACE_ROW_LIMIT = 5000;
export const DEVICE_INTERFACE_DATA_SOURCE = {
    url: '/query/admin/interfaces',
    crudUrl: '/query/admin/interfaces',
    totalProperty: 'count',
    countOfOnProperty: 'countOfOn',
    countOfOffProperty: 'countOfOff',
    countOfEnabledProperty: 'countOfEnabled',
    countOfDisabledProperty: 'countOfDisabled',
    dataProperty: 'data',
    params: {
        searchFields: [
            NAME_FIELD,
            DESCRIPTION_FIELD,
            IF_TYPE_FIELD,
            DEVICE_NAME_FIELD,
            IF_MODE_FIELD,
            IF_ADMIN_STATUS_FIELD,
            IF_OP_STATUS_TEXT_FIELD,
            POLLING_STATUS_FIELD,
            PRIORITY_STATUS_FIELD,
            CB_QOS_CLASSES_NAME_FIELD,
        ],
        rowStart: 0,
        rowLimit: DEVICE_INTERFACE_ROW_LIMIT,
    },
};

export const INTERFACE_DELETED_FALSE_SOURCE = { deleted: false };
const ROW_LIMIT = 100;
export const MONITORED_INTERFACE_DATA_SOURCE = {
    url: '/query/admin/interfaces',
    crudUrl: '/query/admin/interfaces',
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: [
            NAME_FIELD,
            DEVICE_NAME_FIELD,
            DEVICE_IP_ADDRESS_FIELD,
            IF_TYPE_FIELD,
            DESCRIPTION_FIELD,
            IF_MODE_FIELD,
            IF_ADMIN_STATUS_FIELD,
            IF_OP_STATUS_TEXT_FIELD,
            POLLING_STATUS_FIELD,
            PRIORITY_STATUS_FIELD,
            PLCNAME_FIELD,
            CB_QOS_CLASSES_NAME_FIELD,
        ],
        rowStart: 0,
        rowLimit: ROW_LIMIT,
        ...INTERFACE_DELETED_FALSE_SOURCE,
    },
};

export const VIRTUAL_INFRASTRUCTURE_DATA_SOURCE = {
    url: '/query/admin/virtualInfrastructureConfig',
    crudUrl: '/ipm/v1/admin/virtualInfrastructureConfig',
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: [
            IPADDRESS_FIELD,
            DESCRIPTION_FIELD,
            NAME_FIELD,
            SUBTYPE_FIELD,
            UISTATE_FIELD,
            MAPPING_CLUSTER_FIELD,
            MAPPING_VCENTER_FIELD,
            MAPPING_RESOURCEPOOL_FIELD,
            MAPPING_TAGS_FIELD,
            MAPPING_HYPERVISORNAME_FIELD,
            MAPPING_DATACENTER_FIELD,
            PLCNAME_FIELD,
        ],
    },
};

// rowLimit=1000, for show as much as more rows, suggest no need to page
export const NO_PAGING_ROW_LIMIT = 1000;
export const INFRASTRUCTURE_LIST_PARAMS = {
    params: {
        entityFields: [IPADDRESS_FIELD, DESCRIPTION_FIELD, NAME_FIELD, UISTATE_FIELD],
        sort: NORM_NAME_FIELD,
        rowStart: 0,
        rowLimit: NO_PAGING_ROW_LIMIT,
    },
};

export const VIRTUAL_MACHINE_LIST_DATA_SOURCE = {
    url: '/ipm/v1/admin/virtualInfrastructureConfig/findVirtualMachineByHypervisor',
};

export const HYPERVISOR_LIST_DATA_SOURCE = {
    url: '/ipm/v1/admin/virtualInfrastructureConfig/findHypervisorByVCenter',
};
export const INFRASTRUCTURE_LIST_REQUEST_PARAMS = JSON.stringify(INFRASTRUCTURE_LIST_PARAMS.params);

const VIRTUAL_LIST_ENABLE_URL = `${VIRTUAL_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/enableDevicesSelection`;
const VIRTUAL_LIST_DISABLE_URL = `${VIRTUAL_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/disableDevicesSelection`;

const VIRTUAL_DETAIL_ENABLE_URL = `${VIRTUAL_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/enableDevice`;
const VIRTUAL_DETAIL_DISABLE_URL = `${VIRTUAL_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/disableDevice`;
const VIRTUAL_VCENTER_DETAIL_DELETE_URL = `${VIRTUAL_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/deleteVCenter`;

export const VIRTUAL_LIST_ENABLE_DISABLE_URLS = {
    [ENABLE]: VIRTUAL_LIST_ENABLE_URL,
    [DISABLE]: VIRTUAL_LIST_DISABLE_URL,
};

const MONITORED_LIST_ENABLE_URL = `${MONITORED_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/enableDevicesSelection`;
const MONITORED_LIST_DISABLE_URL = `${MONITORED_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/disableDevicesSelection`;
export const MONITORED_LIST_DELETE_URL = `${MONITORED_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/deleteDevicesSelection`;
const MONITORED_LIST_PRE_DELETE_URL = `${MONITORED_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/preDeleteDevicesSelection`;
const MONITORED_LIST_RESCAN_URL = `/ngp/v2/devices/reclassify`;
export const MONITORED_LIST_ENABLE_DISABLE_URLS = {
    [ENABLE]: MONITORED_LIST_ENABLE_URL,
    [DISABLE]: MONITORED_LIST_DISABLE_URL,
    [DELETE]: MONITORED_LIST_DELETE_URL,
    [PRE_DELETE]: MONITORED_LIST_PRE_DELETE_URL,
    [RESCAN]: MONITORED_LIST_RESCAN_URL,
};

// Monitored Device Detail - Action URLs (same endpoints as list, separate constants for clarity)
const MONITORED_DETAIL_ENABLE_URL = `${MONITORED_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/enableDevicesSelection`;
const MONITORED_DETAIL_DISABLE_URL = `${MONITORED_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/disableDevicesSelection`;
const MONITORED_DETAIL_DELETE_URL = `${MONITORED_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/deleteDevicesSelection`;
export const MONITORED_DETAIL_PRE_DELETE_URL = `${MONITORED_INFRASTRUCTURE_DATA_SOURCE.crudUrl}/preDeleteDevicesSelection`;
export const MONITORED_DETAIL_RESCAN_URL = '/ngp/v2/devices/reclassify';

export const DEVICE_DETAIL_ACTION_URLS = {
    [ENABLE]: MONITORED_DETAIL_ENABLE_URL,
    [DISABLE]: MONITORED_DETAIL_DISABLE_URL,
    [DELETE]: MONITORED_DETAIL_DELETE_URL,
    [PRE_DELETE]: MONITORED_DETAIL_PRE_DELETE_URL,
    [RESCAN]: MONITORED_DETAIL_RESCAN_URL,
};

export const LIST_NEED_ALERT = true;
export const DETAIL_NO_NEED_ALERT = false;

export const VIRTUAL_DETAIL_ENABLE_DISABLE_URLS = {
    [ENABLE]: VIRTUAL_DETAIL_ENABLE_URL,
    [DISABLE]: VIRTUAL_DETAIL_DISABLE_URL,
    [DELETE]: VIRTUAL_VCENTER_DETAIL_DELETE_URL,
};

export const VIRTUAL_ACTIONS = Object.keys(VIRTUAL_DETAIL_ENABLE_DISABLE_URLS);

export const POLLING_STATUS_DISABLED_VALUE = 'disabled';
const POLLING_STATUS_DISABLED_TEXT = 'Disabled';
export const POLLING_STATUS_DOWN_VALUE = 'down';
const POLLING_STATUS_DOWN_TEXT = 'Down';
const POLLING_STATUS_NEW_VALUE = 'new';
const POLLING_STATUS_NEW_TEXT = 'New';
const POLLING_STATUS_UP_VALUE = 'up';
const POLLING_STATUS_UP_TEXT = 'Up';
const POLLING_STATUS_UNKNOWN_VALUE = 'unknown';
const POLLING_STATUS_UNKNOWN_TEXT = 'Unknown';

export const POLLING_STATUS_OPTIONS = {
    [POLLING_STATUS_DISABLED_VALUE]: POLLING_STATUS_DISABLED_TEXT,
    [POLLING_STATUS_DOWN_VALUE]: POLLING_STATUS_DOWN_TEXT,
    [POLLING_STATUS_NEW_VALUE]: POLLING_STATUS_NEW_TEXT,
    [POLLING_STATUS_UP_VALUE]: POLLING_STATUS_UP_TEXT,
    [POLLING_STATUS_UNKNOWN_VALUE]: POLLING_STATUS_UNKNOWN_TEXT,
};

const HOSTNAME_CANNOT_BE_RESOLVED_REGEX = /getaddrinfo ENOTFOUND\s+(\S+)/;
export const extractHostname = (message) => {
    const match = message.match(HOSTNAME_CANNOT_BE_RESOLVED_REGEX);
    return match ? match[1] : null;
};

export const NEW_DEVICE_TYPE = 'new';
export const ROUTER = 'router';
export const SWITCH = 'switch';
export const FIREWALL = 'firewall';
export const PACKET_PROCESSOR = 'packet-processor';
export const GENERIC = 'generic';
export const SERVER = 'server';
export const WIRELESSCONTROLLER = 'wirelesscontroller';
export const ACCESSPOINT = 'accesspoint';
export const DEVICE_FILTER_ID = 'Device';
export const SERVER_FILTER_ID = 'Server';
export const WIRELESSCONTROLLER_FILTER_ID = 'WirelessController';
export const ACCESSPOINT_FILTER_ID = 'AccessPoint';

export const HYPERVISOR_FILTER_ID = 'Hypervisor';
export const VIRTUAL_MACHINE_FILTER_ID = 'VirtualMachine';

export const isNewDevice = (deviceType) => deviceType === NEW_DEVICE_TYPE;
